import axios, { AxiosInstance, CancelToken, AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { ApiException, ClinicDTO } from "../ClientDTO";
import { PublicServiceDTO } from "../ShoppingCart/ShoppingCartClientDTO";
import { ModelEntityDTO, PatientCalendarDoctorDTO, PatientCalendarSlotDTO, PortalScheduleSamplingDTO, SamplingScheduleOptionDTO } from "./PatientCalendarClientDTO";
import { AppointmentDoctorDTO } from "./PatientCalendarClientDTO";
export class PatientCalendarClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();
        this.instance.interceptors.request.use(
          config => {
              const token = localStorage.getItem('accessToken');
              if (token) {
                  if (!config.headers) {
                      config.headers = {};
                  }
                  config.headers['Authorization'] = `Bearer ${token}`;
              }
              return config;
          },
          error => {
              return Promise.reject(error);
          }
      );
        this.baseUrl = baseUrl ?? "";
  
    }

        getsamplingofficeslots(clinicId?: number | undefined, date?: Date | undefined, cancelToken?: CancelToken): Promise<SamplingScheduleOptionDTO[]> {
            let url_ = this.baseUrl + "/api/patient/calendar/getsamplingofficeslots?";
            if (clinicId === null)
                throw new Error("The parameter 'clinicId' cannot be null.");
            else if (clinicId !== undefined)
                url_ += "clinicId=" + encodeURIComponent("" + clinicId) + "&";
            if (date === null)
                throw new Error("The parameter 'date' cannot be null.");
            else if (date !== undefined)
                url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
            url_ = url_.replace(/[?&]$/, "");
    
            let options_: AxiosRequestConfig = {
                method: "GET",
                url: url_,
                headers: {
                    "Accept": "text/plain"
                },
                cancelToken
            };
    
            return this.instance.request(options_).catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            }).then((_response: AxiosResponse) => {
                return this.processGetsamplingofficeslots(_response);
            });
        }
    
        protected processGetsamplingofficeslots(response: AxiosResponse): Promise<SamplingScheduleOptionDTO[]> {
            const status = response.status;
            let _headers: any = {};
            if (response.headers && typeof response.headers === "object") {
                for (const k in response.headers) {
                    if (response.headers.hasOwnProperty(k)) {
                        _headers[k] = response.headers[k];
                    }
                }
            }
            if (status === 200) {
                const _responseText = response.data;
                let result200: any = null;
                let resultData200  = _responseText;
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SamplingScheduleOptionDTO.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return Promise.resolve<SamplingScheduleOptionDTO[]>(result200);
    
            } else if (status !== 200 && status !== 204) {
                const _responseText = response.data;
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }
            return Promise.resolve<SamplingScheduleOptionDTO[]>(null as any);
        }

      schedulesampling(body?: PortalScheduleSamplingDTO | undefined, cancelToken?: CancelToken): Promise<boolean> {
          let url_ = this.baseUrl + "/api/patient/calendar/schedulesampling";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: AxiosRequestConfig = {
              data: content_,
              method: "POST",
              url: url_,
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "text/plain"
              },
              cancelToken
          };
  
          return this.instance.request(options_).catch((_error: any) => {
              if (isAxiosError(_error) && _error.response) {
                  return _error.response;
              } else {
                  throw _error;
              }
          }).then((_response: AxiosResponse) => {
              return this.processSchedulesampling(_response);
          });
      }
  
      protected processSchedulesampling(response: AxiosResponse): Promise<boolean> {
          const status = response.status;
          let _headers: any = {};
          if (response.headers && typeof response.headers === "object") {
              for (const k in response.headers) {
                  if (response.headers.hasOwnProperty(k)) {
                      _headers[k] = response.headers[k];
                  }
              }
          }
          if (status === 200) {
              const _responseText = response.data;
              let result200: any = null;
              let resultData200  = _responseText;
                  result200 = resultData200 !== undefined ? resultData200 : <any>null;
      
              return Promise.resolve<boolean>(result200);
  
          } else if (status !== 200 && status !== 204) {
              const _responseText = response.data;
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          }
          return Promise.resolve<boolean>(null as any);
      }
  


    /**
     * @param searchTerm (optional) 
     * @param serviceId (optional) 
     * @param medicalProfileId (optional) 
     * @return OK
     */
  getclinics( cancelToken?: CancelToken): Promise<ClinicDTO[]> {
         let url_ = this.baseUrl + "/api/patient/calendar/getclinics";
         url_ = url_.replace(/[?&]$/, "");
 
         let options_: AxiosRequestConfig = {
             method: "GET",
             url: url_,
             headers: {
                 "Accept": "text/plain"
             },
             cancelToken
         };
 
         return this.instance.request(options_).catch((_error: any) => {
             if (isAxiosError(_error) && _error.response) {
                 return _error.response;
             } else {
                 throw _error;
             }
         }).then((_response: AxiosResponse) => {
             return this.processGetclinics(_response);
         });
     }
 
     protected processGetclinics(response: AxiosResponse): Promise<ClinicDTO[]> {
         const status = response.status;
         let _headers: any = {};
         if (response.headers && typeof response.headers === "object") {
             for (const k in response.headers) {
                 if (response.headers.hasOwnProperty(k)) {
                     _headers[k] = response.headers[k];
                 }
             }
         }
         if (status === 200) {
             const _responseText = response.data;
             let result200: any = null;
             let resultData200  = _responseText;
             if (Array.isArray(resultData200)) {
                 result200 = [] as any;
                 for (let item of resultData200)
                     result200!.push(ClinicDTO.fromJS(item));
             }
             else {
                 result200 = <any>null;
             }
             return Promise.resolve<ClinicDTO[]>(result200);
 
         } else if (status !== 200 && status !== 204) {
             const _responseText = response.data;
             return throwException("An unexpected server error occurred.", status, _responseText, _headers);
         }
         return Promise.resolve<ClinicDTO[]>(null as any);
     }
 
      createAppointment(body?: AppointmentDoctorDTO | undefined, cancelToken?: CancelToken): Promise<boolean> {
            let url_ = this.baseUrl + "/api/patient/calendar/createAppointment";
            url_ = url_.replace(/[?&]$/, "");
    
            const content_ = JSON.stringify(body);
    
            let options_: AxiosRequestConfig = {
                data: content_,
                method: "POST",
                url: url_,
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "text/plain"
                },
                cancelToken
            };
    
            return this.instance.request(options_).catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            }).then((_response: AxiosResponse) => {
                return this.processCreateAppointment(_response);
            });
        }
    
        protected processCreateAppointment(response: AxiosResponse): Promise<boolean> {
            const status = response.status;
            let _headers: any = {};
            if (response.headers && typeof response.headers === "object") {
                for (const k in response.headers) {
                    if (response.headers.hasOwnProperty(k)) {
                        _headers[k] = response.headers[k];
                    }
                }
            }
            if (status === 200) {
                const _responseText = response.data;
                let result200: any = null;
                let resultData200  = _responseText;
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
        
                return Promise.resolve<boolean>(result200);
    
            } else if (status !== 200 && status !== 204) {
                const _responseText = response.data;
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }
            return Promise.resolve<boolean>(null as any);
        }
    doctorsbyservicesandmedicalprofileautocomplete(searchTerm?: string | undefined, serviceId?: number | undefined, medicalProfileId?: number | undefined, cancelToken?: CancelToken): Promise<PatientCalendarDoctorDTO[]> {
        let url_ = this.baseUrl + "/api/patient/calendar/doctorsbyservicesandmedicalprofileautocomplete?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (medicalProfileId === null)
            throw new Error("The parameter 'medicalProfileId' cannot be null.");
        else if (medicalProfileId !== undefined)
            url_ += "MedicalProfileId=" + encodeURIComponent("" + medicalProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoctorsbyservicesandmedicalprofileautocomplete(_response);
        });
    }

    protected processDoctorsbyservicesandmedicalprofileautocomplete(response: AxiosResponse): Promise<PatientCalendarDoctorDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientCalendarDoctorDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientCalendarDoctorDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientCalendarDoctorDTO[]>(null as any);
    }

 /**
     * @return OK
     */
    parentservicetypes( cancelToken?: CancelToken): Promise<ModelEntityDTO[]> {
        let url_ = this.baseUrl + "/api/patient/calendar/parentservicetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processParentservicetypes(_response);
        });
    }

    protected processParentservicetypes(response: AxiosResponse): Promise<ModelEntityDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelEntityDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ModelEntityDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelEntityDTO[]>(null as any);
    }
    
     /**
        * @param searchTerm (optional) 
        * @param parentServiceTypeId (optional) 
        * @return OK
        */
       servicesautocomplete(searchTerm?: string | undefined, parentServiceTypeId?: number | undefined, cancelToken?: CancelToken): Promise<ModelEntityDTO[]> {
           let url_ = this.baseUrl + "/api/patient/calendar/servicesautocomplete?";
           if (searchTerm === null)
               throw new Error("The parameter 'searchTerm' cannot be null.");
           else if (searchTerm !== undefined)
               url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
           if (parentServiceTypeId === null)
               throw new Error("The parameter 'parentServiceTypeId' cannot be null.");
           else if (parentServiceTypeId !== undefined)
               url_ += "parentServiceTypeId=" + encodeURIComponent("" + parentServiceTypeId) + "&";
           url_ = url_.replace(/[?&]$/, "");
   
           let options_: AxiosRequestConfig = {
               method: "GET",
               url: url_,
               headers: {
                   "Accept": "text/plain"
               },
               cancelToken
           };
   
           return this.instance.request(options_).catch((_error: any) => {
               if (isAxiosError(_error) && _error.response) {
                   return _error.response;
               } else {
                   throw _error;
               }
           }).then((_response: AxiosResponse) => {
               return this.processServicesautocomplete(_response);
           });
       }
   
       protected processServicesautocomplete(response: AxiosResponse): Promise<ModelEntityDTO[]> {
           const status = response.status;
           let _headers: any = {};
           if (response.headers && typeof response.headers === "object") {
               for (const k in response.headers) {
                   if (response.headers.hasOwnProperty(k)) {
                       _headers[k] = response.headers[k];
                   }
               }
           }
           if (status === 200) {
               const _responseText = response.data;
               let result200: any = null;
               let resultData200  = _responseText;
               if (Array.isArray(resultData200)) {
                   result200 = [] as any;
                   for (let item of resultData200)
                       result200!.push(ModelEntityDTO.fromJS(item));
               }
               else {
                   result200 = <any>null;
               }
               return Promise.resolve<ModelEntityDTO[]>(result200);
   
           } else if (status !== 200 && status !== 204) {
               const _responseText = response.data;
               return throwException("An unexpected server error occurred.", status, _responseText, _headers);
           }
           return Promise.resolve<ModelEntityDTO[]>(null as any);
       }

    /**
     * @param serviceId (optional) 
     * @return OK
     */
    servicebyid(serviceId?: number | undefined, cancelToken?: CancelToken): Promise<PublicServiceDTO> {
        let url_ = this.baseUrl + "/api/patient/calendar/servicebyid?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServicebyid(_response);
        });
    }

    protected processServicebyid(response: AxiosResponse): Promise<PublicServiceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicServiceDTO.fromJS(resultData200);
            return Promise.resolve<PublicServiceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicServiceDTO>(null as any);
    }

    /**
     * @param currentWeekDate (optional) 
     * @return OK
     */
    getemptyslots(doctorId: number, serviceId: number, selectedClinicId: number, currentWeekDate?: Date | undefined, cancelToken?: CancelToken): Promise<PatientCalendarSlotDTO[]> {
        let url_ = this.baseUrl + "/api/patient/calendar/getemptyslots/{DoctorId}/{ServiceId}/{SelectedClinicId}?";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{DoctorId}", encodeURIComponent("" + doctorId));
        if (serviceId === undefined || serviceId === null)
            throw new Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{ServiceId}", encodeURIComponent("" + serviceId));
        if (selectedClinicId === undefined || selectedClinicId === null)
            throw new Error("The parameter 'selectedClinicId' must be defined.");
        url_ = url_.replace("{SelectedClinicId}", encodeURIComponent("" + selectedClinicId));
        if (currentWeekDate === null)
            throw new Error("The parameter 'currentWeekDate' cannot be null.");
        else if (currentWeekDate !== undefined)
            url_ += "currentWeekDate=" + encodeURIComponent(currentWeekDate ? "" + currentWeekDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetemptyslots(_response);
        });
    }

    protected processGetemptyslots(response: AxiosResponse): Promise<PatientCalendarSlotDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientCalendarSlotDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientCalendarSlotDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientCalendarSlotDTO[]>(null as any);
    }
}
function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}